import { getResponseData, type ApiClient } from "@/modules/api/apiClient.ts";
import { getResourceIconClass } from "@/modules/api/resourceTypes.tsx";
import { queryKey as billingAccountListQueryKey } from "@/modules/billing/billingAccountQuery.ts";
import { raiseRequestToast, type Toast } from "@/modules/notifications/toast.tsx";
import { jsonEncodedBody } from "@/utils/fetchClient.ts";
import { mutationOptions } from "@/utils/query/runMutation.ts";
import type { QueryClient } from "@tanstack/react-query";

const toastOptions: Partial<Toast> = { icon: getResourceIconClass("billing_account") };

export function startDigioKycMutation(api: ApiClient, queryClient: QueryClient) {
    return mutationOptions({
        mutationKey: ["digio_kyc_start"],
        async mutationFn({ billing_account_id }: { billing_account_id: number; try_continue?: boolean }) {
            return getResponseData(
                await api.POST("/payment/kyc/start", {
                    ...jsonEncodedBody,
                    body: { billing_account_id },
                }),
            );
        },
        async onSettled(_res, err, { try_continue }) {
            raiseRequestToast(err, {
                ...toastOptions,
                success: try_continue ? "Billing account validation resumed" : "Billing account validation started",
                error: try_continue
                    ? "Error resuming billing account validation"
                    : "Error starting billing account validation",
            });
            await queryClient.invalidateQueries({ queryKey: billingAccountListQueryKey });
        },
    });
}
